import { lazy, Suspense } from 'react';
import { MotionConfig } from 'framer-motion';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PitchPage } from '@/pages/PitchPage';
import { PitchV5Page } from '@/pages/PitchV5Page';
import { RoiPage } from '@/pages/RoiPage';
import { SignUpPage } from '@/pages/SignUpPage';
import { RequestAccessPage } from '@/pages/RequestAccessPage';
import { WebsiteLegalPage } from '@/pages/WebsiteLegalPage';

const PitchV3Page = lazy(() =>
  import('@/pages/PitchV3Page').then(({ PitchV3Page: Page }) => ({
    default: Page,
  })),
);

export function App() {
  return (
    // `reducedMotion="user"` neutralises every transform and layout
    // animation for visitors who ask for reduced motion, without us
    // threading a hook through forty callsites. Opacity still fades, so
    // reveals stay legible rather than disappearing.
    <MotionConfig reducedMotion="user">
      <BrowserRouter
        future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
      >
        <Routes>
          <Route path="/" element={<SignUpPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/request-access" element={<RequestAccessPage />} />
          <Route
            path="/privacy"
            element={<WebsiteLegalPage document="privacy" />}
          />
          <Route
            path="/terms"
            element={<WebsiteLegalPage document="terms" />}
          />
          <Route
            path="/cookies"
            element={<WebsiteLegalPage document="cookies" />}
          />
          <Route path="/pitch" element={<PitchPage />} />
          <Route path="/pitch-v2" element={<PitchV5Page />} />
          <Route
            path="/pitch-v3"
            element={
              <Suspense fallback={null}>
                <PitchV3Page />
              </Suspense>
            }
          />
          <Route path="/pitch-v5" element={<PitchV5Page />} />
          <Route path="/roi" element={<RoiPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </MotionConfig>
  );
}
